<template>
	<div>
		<header class="page-title">
			<h2>Articles</h2>
			<div class="ml-auto">
				<a v-if="userRoles.includes('site_settings.update')" href="#" class="btn btn-md btn-success" @click="saveSettings"><i class="fas fa-save"></i> Save Changes</a>
			</div>
		</header>

		<div class="grid--nav-horizontal" v-if="activeHorizontalTab">
			<nav class="nav-horizontal">
				<ul>
					<li :class="[activeHorizontalTab.name === tab.name ? 'active ' + tab.name : tab.name]" v-for="tab in horizontalTabs" v-if="!tab.disabled">
						<span v-if="tab.disabled">{{ tab.displayName }}</span>
						<a @click.prevent="setActiveHorizontalTab(tab)" v-if="!tab.disabled"> {{ tab.displayName }}</a>
					</li>
				</ul>
			</nav>
			<div class="nav-horizontal-contents" :key="state">
				<div class="grid--nav-horizontal">
					<nav class="nav-horizontal">
						<ul>
							<li :class="[selectedCategory.subGroup === category.subGroup ? 'active ' + category.subGroup : category.subGroup]" v-for="category in categories">
								<a @click.prevent="setActiveCategory(category)"> {{ category.title }}</a>
							</li>
						</ul>
					</nav>
					<div class="nav-horizontal-contents" v-if="selectedCategory.hasOwnProperty('title')">
						<p>
							<a :href="selectedCategory.url" target="_blank">Click here</a> to go to the corresponding Meta & SEO page.
						</p>
						<div class="card">
							<header class="card-header language-list">
								<lang-selector></lang-selector>
							</header>
							<div class="card-body">
								<div class="form-group">
									<label :for="selectedCategory.subGroup + '.sub_heading'">Intro text</label>
									<textarea :id="selectedCategory.subGroup + '.sub_heading'" v-model="settings[selectedCategory.subGroup]['sub_heading'][clickedLang].text_value"></textarea>
								</div>
							</div>
						</div>
						<div class="mb-2" v-for="(type, typeKey) in selectedCategory.types" v-if="selectedCategory.types">
							<h4 class="card-subtitle">{{ type.title }}</h4>
							<table>
								<thead>
									<tr>
										<th>Position</th>
										<th>Article</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="row in [1, 2, 3, 4]">
										<td>{{ row }}.</td>
										<td>
											<select3 :value.sync="settings[selectedCategory.subGroup][type.key][row].value" :data="type.articles" :config="selectConfig"></select3>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>

		<loader></loader>
	</div>
</template>

<script>
	import VueSelect from '../../../../node_modules/vue-select';
	import {eventBus} from "../../app";

	export default {
		components: {
			VueSelect
		},
		data() {
			return {
				userRoles: this.$currentUserRoles,
				selectConfig: {
					keyName: 'id',
					valueName: 'title',
					originalValue: true
				},
				settings: {},

				selectedCategory: {},
				categories: [],

				providerTypeHubSettings: [],
				providerTypeCategoryHubSettings: [],

				horizontalTabs: [
					{
						name: 'horizontalCategories',
						displayName: 'Category Hubs',
						slug: 'categories',
						disabled: false,
					},
					{
						name: 'horizontalTypes',
						displayName: 'Provider Type Hubs',
						slug: 'provider-types',
						disabled: false,
					},
					{
						name: 'horizontalTypeCategories',
						displayName: 'Provider Type Category Hubs',
						slug: 'provider-type-categories',
						disabled: false,
					},
				],
				activeHorizontalTab: {},

				clickedLang: this.$defaultLanguage.locale,
				state: 0
			}
		},
		mounted() {
			let vm = this;
			vm.setActiveHorizontalTab(vm.horizontalTabs[0]);

			// When setActiveStatus method ran, change selected data in form fields
			/* From LangSelector */
			eventBus.$on('setActiveStatus', function (clickedLang) {
				vm.clickedLang = clickedLang;
			});
		},
		methods: {
			getSettings: function () {
				eventBus.$emit('onLoaderStart');
				let vm = this;
				axios.get('/api/' + vm.$selectedSite.slug + '/settings/' + vm.activeHorizontalTab.slug)
					.then(response => {
						vm.parseData(response.data);
						vm.$toastr.success('General data loaded successfully', 'Success');
					})
					.catch(e => {
						eventBus.$emit('onLoaderFinish');
						this.$toastr.error('General data load failed.', 'Error');
					});
			},
			saveSettings: function () {
				eventBus.$emit('onLoaderStart');
				let vm = this;
				let tmpSettings = _.cloneDeep(vm.settings);
				for (let i = 0; i < vm.categories.length; i++) {
					for (let t = 0; t < vm.$availableLanguages.length; t++) {
						if (vm.settings[vm.categories[i].subGroup]['sub_heading'] && (vm.settings[vm.categories[i].subGroup]['sub_heading'][vm.$availableLanguages[t].locale].text_value === null || vm.settings[vm.categories[i].subGroup]['sub_heading'][vm.$availableLanguages[t].locale].text_value === '')) {
							delete vm.settings[vm.categories[i].subGroup]['sub_heading'][vm.$availableLanguages[t].locale];
						}
					}
				}

				let postUrl = '/api/' + vm.$selectedSite.slug + '/hub-settings';
				if (vm.activeHorizontalTab.slug === 'provider-type-categories') {
					postUrl = '/api/' + vm.$selectedSite.slug + '/settings'
				}

				axios.post(postUrl, vm.settings)
					.then(response => {
						vm.$toastr.success('General data saved successfully', 'Success');
						vm.settings = tmpSettings;

						eventBus.$emit('onLoaderFinish');
					})
					.catch(e => {
						this.$toastr.error('General data save failed.', 'Error');
						vm.settings = tmpSettings;

						eventBus.$emit('onLoaderFinish');
					});
			},
			parseData: function (data) {
				let vm = this;
				vm.categories = data.choices.categories;
				vm.settings = {};

				for (let i = 0; i < vm.categories.length; i++) {
					let translations = data.siteSettings.find(element => element.subGroup === vm.categories[i].subGroup && element.key === 'sub_heading');

					vm.settings[vm.categories[i].subGroup] = {
						sub_heading: {
							'group': 'hub_pages',
							'subGroup': vm.categories[i].subGroup,
							'key': 'sub_heading',
							'value': null,
							'order': 1
						}
					};

					for (let t = 0; t < vm.$availableLanguages.length; t++) {
						if (translations && translations.translations[vm.$availableLanguages[t].locale]) {
							vm.settings[vm.categories[i].subGroup]['sub_heading'][vm.$availableLanguages[t].locale] = {
								text_value: translations.translations[vm.$availableLanguages[t].locale].text_value,
							}
						} else {
							vm.settings[vm.categories[i].subGroup]['sub_heading'][vm.$availableLanguages[t].locale] = {
								text_value: null,
							};
						}
					}

					if (vm.activeHorizontalTab.slug !== 'provider-type-categories') {
						for (let j = 0; j < vm.categories[i].types.length; j++) {
							vm.settings[vm.categories[i].subGroup][vm.categories[i].types[j].key] = {};
							for (let k = 1; k < 5; k++) {
								let top_four = data.siteSettings.find(element => element.subGroup === vm.categories[i].subGroup && element.key === vm.categories[i].types[j].key && element.order === k);
								if (top_four) {
									vm.settings[vm.categories[i].subGroup][vm.categories[i].types[j].key][k] = top_four;
									vm.settings[vm.categories[i].subGroup][vm.categories[i].types[j].key][k].group = 'hub_pages';
									vm.settings[vm.categories[i].subGroup][vm.categories[i].types[j].key][k].subGroup = vm.categories[i].subGroup;
									vm.settings[vm.categories[i].subGroup][vm.categories[i].types[j].key][k].value = vm.categories[i].types[j].articles.find(article => article.id === parseInt(top_four.value));
									vm.settings[vm.categories[i].subGroup][vm.categories[i].types[j].key][k].order = k;

								} else {
									vm.settings[vm.categories[i].subGroup][vm.categories[i].types[j].key][k] = {
										group: 'hub_pages',
										subGroup: vm.categories[i].subGroup,
										key: vm.categories[i].types[j].key,
										order: k
									};
								}
							}
						}
					}
				}

				vm.setActiveCategory(vm.categories[0]);
				vm.state++;

				eventBus.$emit('onLoaderFinish');
			},
			setActiveCategory: function (category) {
				let vm = this;
				vm.selectedCategory = category;
			},
			setActiveHorizontalTab: function (horizontalTab) {
				let vm = this;

				vm.activeHorizontalTab = horizontalTab;
				vm.getSettings();
			},
		}
	}
</script>

<style scoped>

</style>
